import { environment } from '../../../lib/environment';

export enum APPMODE {
    ESTIMATE = 'estimate',
    PROJECTION = 'projection',
}

interface IAppMode {
    getAppMode: () => APPMODE;
    isAppMode: (appMode: APPMODE) => boolean;
    appVersion: string;
}

function getAppMode(unitId: string | undefined): APPMODE {
    return unitId ? APPMODE.ESTIMATE : APPMODE.PROJECTION;
}

export function initAppmode(unitId: string | undefined): IAppMode {
    return {
        getAppMode: () => getAppMode(unitId),
        isAppMode: (appMode: APPMODE) => getAppMode(unitId) === appMode,
        appVersion: environment.REACT_APP_VERSION() || 'local',
    };
}
